/** CrossCastr mark — a broadcast node with radiating waves (azure, AzriaSolutions DNA).
 * All geometry sits inside 6..42 so it never clips in its container. Matches /favicon.svg.
 * Never mirrored in RTL (DESIGN.md §4). */
export function BrandMark({ size = 38 }: { size?: number }): JSX.Element {
  return (
    <svg className="mark" viewBox="0 0 48 48" fill="none" aria-hidden="true"
      style={{ width: size, height: size, overflow: 'visible' }}>
      <defs>
        <linearGradient id="ccMark" x1="6" y1="6" x2="42" y2="42" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#3DA8E4" />
          <stop offset="1" stopColor="#1C74AA" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="44" height="44" rx="12" fill="#0F3C3C" />
      <circle cx="17" cy="24" r="3.4" fill="url(#ccMark)" />
      <path d="M24 15c5 2.5 8 6 8 9s-3 6.5-8 9" stroke="url(#ccMark)" strokeWidth="3" strokeLinecap="round" fill="none" />
      <path d="M27 10c7 3.5 11 8.5 11 14s-4 10.5-11 14" stroke="url(#ccMark)" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.6" />
    </svg>
  );
}
